export const crmAppLanguageEnglish = {
    'ra-audit-log': {
        record_event: {
            comment: 'New published comment',
            copyscape: '',
            PostLinkCheck: 'Post Link Check Succeeded',
            PostChangeStatus: 'updated: ',
            declined_with_comment: 'declined with comment: ', // here doesn't work space and nbsp, why?
            declined: 'declined',
        },
    },
    ra: {
        action: {
            edit: '',
        },
    },
    post: {
        changes_were_not_saved: 'The changes were not saved!',
    },
    offers: {
        potential_campaigns: {
            show_only_without_offer_website: 'Without Offer Website',
        },
    },
    bonus: {
        changes_were_edited: 'Bonus successfully edited',
    },
    adzz: {
        auth: {
            token_expired: 'Token expired. Please log in again.',
        },
        resources: {
            v1_Posts: {
                fields: {
                    new_ContentOrderStatus: 'Content Status',
                    new_PostStatus: 'Post Status',
                    new_OutreachStatus: 'Outreach Status',
                    new_TextHTMLbody: 'body',
                    writer_id: 'writer',
                    new_name: 'Source URL',
                    approver_id: 'To Be Approved By',
                    requestedfrom_id: 'Requested From',
                    supplier_id: 'Supplier',
                    new_Supplierprice: 'Supplier Price',
                    new_ContentCost: 'Content Cost',
                    new_UploadPrice: 'Upload Price',
                    PublisherStatus: 'Publisher status',
                    AdvertiserStatus: 'Advertiser status',
                    comp_total_price_writer: 'Writer Fee',
                    comp_total_price_manager: 'Total Price',
                },
                insert: {
                    created: '%{affected_rows} posts was created. IDs: %{ids}',
                    errorApollo: '%{err}',
                },
            },
        },
        livePosts: {
            created: '%{affected_rows} posts were created. IDs: %{ids}',
            errorApollo: '%{err}',
        },
        importWebsitesStatistics: {
            created:
                '%{affected_rows} websites were created/updated. IDs: %{ids}',
            errorApollo: '%{err}',
        },
    },
};
